import React from 'react'
import Textarea from 'src/Common/ui/textArea'
import PropTypes from 'prop-types'

function Remarks ({ remark, setRemark, errors, control, required }) {
    const handleRemarkInput = (e) => {
        setRemark(e)
    }
    return (
        <div>
            <div>
                <Textarea
                    label='Remarks'
                    errors={errors}
                    control={control}
                    required={required}
                    rules={{
                        validate: (value) => {
                            if (!required) return true
                            if (value.length < 251) {
                                return true
                            } else if (value.length === 0) {
                                return 'This field is required'
                            } else {
                                return 'Characters should be less than 250'
                            }
                        }
                    }}
                    name={'remarks-question'}
                    type="text"
                    onValueChange={handleRemarkInput}
                    value={remark}
                    defaultValue={remark}
                    className='!border-[2px] !border-[hsl(var(--primary-table-head))]!ring-0 !shadow-none !ml-0'
                />
            </div>
        </div>
    )
}
Remarks.propTypes = {
    remark: PropTypes.any,
    setRemark: PropTypes.any,
    control: PropTypes.any
}
export default Remarks
